export default "__VITE_ASSET__e4de8e50__"